import React from 'react';
import config from '../config';
import DashboardInitializer from '../dashboards/DashboardInitializer';
import apiPaths from '../apiPaths';

const LicenciaDashboard = (props) => {
  const components = [
    {
      params: {
        type: 'search',
        componentId: 'licencialicenciaSearch',
        panelHeader: 'Llicència',
        panelKey: 'licencialicenciaSearch',
        yPosition: 0,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabIndex: 0,
        tabTitle: '',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 0,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'fkLibro.id',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'fkArea.id',
                  yPosition: 1,
                  xPosition: 2,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'fkCurso.id',
                  yPosition: 2,
                  xPosition: 1,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'estado',
                  yPosition: 2,
                  xPosition: 2,
                  mustRender: true,
                  width: 12,
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Llibre',
          key: 'fkLibro.id',
          type: 'combo',
          operand: 'like',
          comboId: 'libro',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Àrea',
          key: 'fkArea.id',
          type: 'combo',
          operand: 'like',
          comboId: 'area',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Curs',
          key: 'fkCurso.id',
          type: 'combo',
          operand: 'like',
          comboId: 'curso',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Estat',
          key: 'estado',
          type: 'checkselect',
          operand: 'like',
          mandatory: false,
          disabled: false,
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
      },
    },
    {
      params: {
        type: 'table',
        componentId: 'licencialicenciaList',
        rowKey: 'id',
        panelHeader: 'Llicència',
        panelKey: 'licencialicenciaList',
        navigationParams: props.query.params.q || '',
        yPosition: 1,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabTitle: '',
        isMainTable: true,
        tabIndex: 0,
        tableType: 0,
      },
      fields: [
        {
          title: 'Id',
          dataIndex: 'id',
          position: 0,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          width: 60,
        },
        {
          title: 'Llibre',
          dataIndex: 'fkLibro.nombre',
          position: 1,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Àrea',
          dataIndex: 'fkArea.nombre',
          position: 2,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Curs',
          dataIndex: 'fkCurso.nombre',
          position: 3,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Estat',
          dataIndex: 'estado',
          position: 4,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          render: 'comboCustom',
          comboId: 'corporate',
        },
      ],
      settings: {
        size: config.COMPONENT.TABLE.SIZE,
        bordered: config.COMPONENT.TABLE.BORDERED,
        editable: true,
        multiple: false,
        canCreate: true,
        canDelete: true,
        scroll: { x: true },
      },
      pagination: {
        defaultPageSize: 50,
        pageSizeOptions: ['5', '10', '20', '50'],
        showQuickJumper: config.COMPONENT.SHOW_QUICK_JUMPER,
        showSizeChanger: config.COMPONENT.TABLE.SHOW_SIZE_CHANGER,
        showTotal: config.COMPONENT.TABLE.SHOW_TOTAL,
        size: config.COMPONENT.TABLE.SIZE,
      },
    },
    {
      params: {
        type: 'edit',
        componentId: 'licencialicenciaEdit',
        panelHeader: 'Llicència',
        panelKey: 'licencialicenciaEdit',
        primaryKey: 'id',
        yPosition: 2,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: true,
        tabIndex: 0,
        tabTitle: 'Llicència',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 2,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'fkLibro.id',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 18,
                },
                {
                  key: 'fkArea.id',
                  yPosition: 2,
                  xPosition: 1,
                  mustRender: true,
                  width: 18,
                },
                {
                  key: 'fkCurso.id',
                  yPosition: 3,
                  xPosition: 1,
                  mustRender: true,
                  width: 18,
                },
                {
                  key: 'estado',
                  yPosition: 4,
                  xPosition: 1,
                  mustRender: true,
                  width: 18,
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Llibre',
          key: 'fkLibro.id',
          type: 'combo',
          unique: false,
          comboId: 'libro',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Àrea',
          key: 'fkArea.id',
          type: 'combo',
          unique: false,
          comboId: 'area',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Curs',
          key: 'fkCurso.id',
          type: 'combo',
          unique: false,
          comboId: 'curso',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Estat',
          key: 'estado',
          type: 'comboCustom',
          comboId: 'corporate',
          unique: false,
          mandatory: false,
          disabled: false,
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
        canEdit: true,
        canCreate: true,
        canDelete: true,
      },
    },
  ];

  const componentId = 'LicenciaDashboard';

  return (
    <DashboardInitializer
      componentId={componentId}
      components={components}
      {...props}
    />
  );
};

export default LicenciaDashboard;
